export class MetricsDataOptimizationModel {
    name;
    action;
    actionArgs;
}
//# sourceMappingURL=metrics-data-optimization.js.map